import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=6c1ccc4a&"
import script from "./ConfirmationDialog.ts?vue&type=script&lang=js&"
export * from "./ConfirmationDialog.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports